// @flow
import * as React from 'react';
import { Box, Text, TextInput } from 'grommet';
import { FormattedMessage } from 'react-intl';


type FiberColorSchemeAttributeProps = {
    fiber: Fiber,
    fiberIndex: number,

}
const FiberColorSchemeAttribute = ({ fiber, fiberIndex }: FiberColorSchemeAttributeProps) => {
    const defaultTextColor = (parseInt(fiber.color.replace('#', ''), 16) > 0xffffff / 2) ? 'black' : 'white';

    return (
        <>
            <Box
                style={{ paddingBottom: 10, paddingTop: 10 }}
                gap="small"
                direction="row-responsive"
                align="center"
                justify="center"
            >

                <div>
                    {fiberIndex === 0 && (
                        <Text alignSelf="start" style={{ paddingLeft: '1.8rem' }}>
                            <FormattedMessage
                                id="adminpage-network-infrastructureprovider-color"
                                defaultMessage="Color"
                            />
                        </Text>
                    )}
                    <Box
                        gap="small"
                        direction="row"
                        align="center"
                        justify="center"
                    
                    >
                        <Text style={{ minWidth: 20 }}>{`#${fiber.id}`}</Text>
                        
                        <Box
                            style={{
                                backgroundColor: fiber.color,
                                borderRadius: 5,
                            }}
                        >
                            <Text
                                style={{
                                    padding: 5,
                                    color: defaultTextColor,
                                    
                                }}
                            >
                                {fiber.color}

                            </Text>
                        </Box>
                    </Box>

                </div>

                <div>
                    {fiberIndex === 0 && (
                        <Text alignSelf="start">
                            <FormattedMessage
                                id="cable-fiber-lines-count"
                                defaultMessage="Stripes count"
                            />
                        </Text>
                    )}
                    <Box
                        gap="small"
                        direction="row"
                        align="center"
                        justify="center"
                    
                    >
                        <TextInput
                            type="number"
                            value={fiber.stripe_count}
                            disabled
                        />
                    </Box>
                </div>

            </Box>
        </>
    );
};


export default FiberColorSchemeAttribute;
